import { Endpoint } from '@/types/api.type.ts';

export const dealerEndpoints: Endpoint[] = [
    {
        name: 'getDealers',
        method: 'get',
        path: '/dealers',
    },
    {
        name: 'getDealer',
        method: 'get',
        path: '/dealers/:id',
    },
    {
        name: 'createDealer',
        method: 'post',
        path: '/dealers',
    },
    {
        name: 'updateDealer',
        method: 'patch',
        path: '/dealers/:id',
    },
    {
        name: 'activateDealer',
        method: 'patch',
        path: '/dealers/activate-dealer/:id',
    },
    {
        name: 'deactivateDealer',
        method: 'patch',
        path: '/dealers/deactivate-dealer/:id',
    },
    {
        name: 'updateDealerLegalEntity',
        method: 'patch',
        path: '/dealers/:id/legal-entity',
    },
    {
        name: 'getDealerUsers',
        method: 'get',
        path: '/dealers/:id/users',
    },
    {
        name: 'getAllActiveDealers',
        method: 'get',
        path: '/dealers/all-active',
    },
];
